import React from 'react';
import IntegrationImage, { integrationImageById } from 'assets/img/integrations';
import { specialIntegrationImageType } from 'helpers/constants';
import styles from './AuditIcon.module.scss';

interface AuditIconProps {
  className?: string;
  itemIntegrationName: string;
}

export const AuditIcon: React.FC<AuditIconProps> = ({ className, itemIntegrationName }) => {
  let integrationIcon: any = '';

  if (itemIntegrationName === 'google_drive') {
    integrationIcon = integrationImageById(
      itemIntegrationName,
      IntegrationImage,
      false,
      styles.icon,
      specialIntegrationImageType.provider
    );
  } else {
    integrationIcon = integrationImageById(
      itemIntegrationName,
      IntegrationImage,
      true,
      styles.icon
    );
  }

  return (
    <div className={className}>
      {integrationIcon ? integrationIcon : <div className={styles.noIcon}></div>}
    </div>
  );
};
